import { OutlineButton, CloseButton } from '../buttons/Buttons'
import { palette, fonts } from '../../styles/variables'
import { translate } from '../../utils/translation'
import { Text } from '../topography'

import Modal, { ModalHeader, ModalContent, ModalFooter } from './Modal'

const desktopStyle = {}

const mobileStyle = {
  width: '100%',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
}

export default ({ onAccept, onDeny, isOpen, onClose, ...rest }) => (
  <Modal
    isOpen={isOpen}
    desktopStyle={desktopStyle}
    mobileStyle={mobileStyle}
    {...rest}
  >
    <ModalHeader>
      <Text
        fontSize="24px"
        mobileFontSize="22px"
        lineHeight="24px"
        fontFamily={fonts.primaryBook}
        textAlign="center"
      >
        {translate('ad_blocker_detected_heading')}
      </Text>
      {onClose && <CloseButton onClick={onClose} styles={{ top: '20px' }} />}
    </ModalHeader>
    <ModalContent style={{ height: 'calc(100% - 200px)' }}>
      <Text
        fontSize="14px"
        lineHeight="26px"
        fontFamily={fonts.primary}
        textAlign="center"
      >
        {translate('ad_blocker_detected_warning')}
      </Text>
    </ModalContent>
    <ModalFooter style={{ display: 'flex', justifyContent: 'center' }}>
      <OutlineButton
        static
        color={palette.darkGray50}
        onClick={onDeny}
        data-testid="ad-block-detect-modal-close-button"
      >
        {translate('close')}
      </OutlineButton>
      <OutlineButton
        static
        onClick={onAccept}
        style={{
          color: palette.white,
          backgroundColor: palette.orange,
        }}
      >
        {translate('ad_blocker_detected_button')}
      </OutlineButton>
    </ModalFooter>
  </Modal>
)
